/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_OcopInputs */

const vi_shop_ocop = /** @type {(inputs: Shop_OcopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCOP (chứng nhận)`)
};

/**

* @param {Shop_OcopInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop = /** @type {((inputs?: Shop_OcopInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_OcopInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop(inputs)
});